export default "<div id=\"kaltura_player_{{playerId}}\"></div>\r\n"